import { useTranslation } from 'react-i18next'

import { PRODUCT_NO_PHOTO_PATH } from '@shared/contants/product'
import { OfflinePurchasePosition } from '@shared/generated'
import ImageWithBg from '@shared/ui/image-with-bg'
import { formatPrice } from '@shared/uttils'


import styles from './styles.module.scss'

interface IOrderItemProps {
  data: OfflinePurchasePosition | null;
}

export default function OrderShopItem ({ data }: IOrderItemProps) {
  const { t: tc } = useTranslation('common')

  return (
    <div key={data?.id} className={styles.orderItem}>
      <ImageWithBg
        className={styles['orderItem__img']}
        src={data?.product?.preview?.url ?? PRODUCT_NO_PHOTO_PATH}
      />
      <p className={styles['orderItem__text']}>{data?.name}</p>
      <span className={styles['orderItem__description']}>
        {data?.count} {tc('weight.piece')}
      </span>
      <div className={styles['orderItem__price']}>
        <span className={styles['orderItem__price-current']}>
          {formatPrice(data?.total ?? 0)}
        </span>
        <span className={styles['orderItem__price-perUnit']}>
          {formatPrice(data?.price ?? 0)} / {tc('weight.pc')}
        </span>
      </div>
    </div>
  )
}
